import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { API_PREFIX, UPLOAD_PREFIX } from './config/appConfig';
import PatientAuthPage from './pages/PatientAuthPage';
import DoctorDetailPage from './pages/DoctorDetailPage';
import DoctorAuthPage from './pages/DoctorAuthPage';
import DoctorMessagesPage from './pages/DoctorMessagesPage';
import DoctorPatientsPage from './pages/DoctorPatientsPage';
import DoctorAppointmentsPage from './pages/DoctorAppoinmentsPage';
import PatientDashBoard from './pages/PatientDashboard';
import PatientProfilePage from './pages/PatientProfilePage';
import PatientSurvey from './pages/PatientSurveyPage';
import DoctorStatisticsPage from './pages/DoctorStatisticsPage';
import DoctorDashboad from './pages/DoctorDashboard';
import DoctorFeedbackPage from './pages/DoctorFeedbackPage';
import PatientBookingHistoryPage from './pages/PatientBookingHistory';
import PatientBookingSummaryPage from './pages/PatientBookingSummary';
import PatientChatDetailPage from './pages/PatientChatDetailPage';
import AdminAuthPage from './pages/AdminAuthPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminSurveyPage from './pages/admin/AdminSurveyPage';
import AdminDetailsUserPage from './pages/admin/AdminDetailsUserPage';
import AdminListUsersPage from './pages/admin/AdminListUsersPage';
import AdminCreateDoctorPage from './pages/admin/AdminCreateDoctor';
import PatientMessagesPage from './pages/PatientMessagesPage';
import DoctorSettingsPage from './pages/DoctorSettingsPage';
import ProtectedAdminRoute from './components/common/ProtectedAdminRoute';
import AdminDoctorListPage from './pages/admin/AdminDoctorListPage';
import AdminDoctorDetailPage from './pages/admin/AdminDoctorDetailPage';
import AdminLogoutPage from './pages/admin/AdminLogoutPage';
import AdminPaymentsPage from './pages/admin/AdminPaymentsPage';
import PaymentSuccessPage from './pages/payment/PaymentSuccessPage';
import AdminAppointmentsPage from './pages/admin/AdminAppoinmentsPage';
import DoctorCalendarPage from './components/doctor/DoctorCalendarPage';
import './styles/global.css';
import NotFoundPage from './pages/NotFoundPage';
import PasswordResetPage from './pages/PasswordResetPage';


const useEnvironmentLogger = () => {
  useEffect(() => {
    const envInfo = {
      environment: process.env.NODE_ENV,
      apiUrl: API_PREFIX,
      timestamp: new Date().toLocaleString()
    };

    console.log('%c [DEBUG] App.js - Environment Information - ', 'background: #222; color: #bada55; padding: 2px;', `ENV: ${process.env.NODE_ENV}, API: ${API_PREFIX}, TIME: ${new Date().toLocaleString()}`);
  }, []);
}

const App = () => {
  useEnvironmentLogger(); // Chiamata del custom hook

  return (
    <Router>
      <div className="min-h-screen bg-gray-100"> {}
        <Routes>
          
          {/* Patient Routes */}
          <Route path="/patient/login" element={<PatientAuthPage />} />
          <Route path="/patient/survey" element={<PatientSurvey />} />
          <Route path="/patient/dashboard" element={<PatientDashBoard />} />
          <Route path="/patient/appoinments" element={<PatientBookingHistoryPage />} />
          <Route path="/patient/profile" element={<PatientProfilePage />} />
          <Route path="/patient/message" element={<PatientMessagesPage />} />
          <Route path="/patient/messagedetails/:id" element={<PatientChatDetailPage />} />
          <Route path="/doctor/:id" element={<DoctorDetailPage />} />
          <Route path="/patient/bookingsummary" element={<PatientBookingSummaryPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/password/reset" element={<PasswordResetPage />} />


          {/* Doctor Routes */}
          <Route path="/doctor/dashboard" element={<DoctorDashboad />} />
          <Route path="/doctor/feedback" element={<DoctorFeedbackPage />} />
          <Route path="/doctor/settings" element={<DoctorSettingsPage />} />
          <Route path="/doctor/stats" element={<DoctorStatisticsPage />} />
          <Route path="/doctor/messages" element={<DoctorMessagesPage />} />
          <Route path="/doctor/appointments" element={<DoctorAppointmentsPage />} />
          <Route path="/doctor/patient" element={<DoctorPatientsPage />} />
          <Route path="/doctor/calendar" element={<DoctorCalendarPage />} />
 

          {/* Admin Routes */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminAuthPage />} />
          <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              } 
              />        
          <Route path="/admin/survey/questions" element={<AdminSurveyPage />} />
          <Route path="/admin/survey/questions/:id" element={<AdminSurveyPage />} />
          <Route path="/admin/doctors" element={<AdminDoctorListPage />} />
          <Route path="/admin/appointments" element={<AdminAppointmentsPage />} />
          <Route path="/admin/doctors/:doctorId" element={<AdminDoctorDetailPage />} />
          <Route path="/admin/doctors/create" element={<AdminCreateDoctorPage />} />
          <Route path="/admin/:userType" element={<AdminListUsersPage />} />
          <Route path="/admin/:userType/:userId" element={<AdminDetailsUserPage />} />   
          <Route path="/admin/payments" element={<AdminPaymentsPage />} />  
          <Route path="/admin/logout" element={<AdminLogoutPage />} />  

          {/* Home route */}
          <Route path="/" element={<PatientAuthPage />} />

          {/* 404 route */}
          <Route path="*" element={<NotFoundPage />} />

        </Routes>
      </div>
    </Router>
  );
};

export default App;